
<template>
  <div id="data-list-list-view" class="data-list-container">

    <vs-alert color="warning" title="Share Link" :active.sync="showShareLink">
      <span>https://unitedats-tms.com/#/ConfirmRequestRegistration/{{ CourseClasssModel.Code }}</span>
    </vs-alert>

    <vx-card class="p-5  mb-5 mt-5" :title="$t('CourseClass')">
      <div class="vx-row">
        <div class="vx-col lg:w-1/4 w-full">
          <label for="ClassNo" class="vs-input--label"> {{ $t('ClassNo') }} </label>
          <br />
          <vs-input disabled v-model="CourseClasssModel.ClassNo" class="w-full" name="ClassNo" />
        </div>

        <div class="vx-col lg:w-1/4">
          <label for="Course" class="vs-input--label"> {{ $t('Course') }} </label>
          <!-- <p>Course</p> -->
          <v-select label="Name" class=" w-full" v-model="CourseClasssModel.CourseID" :options="Courses" autocomplete
            :reduce="Course => Course.ID" @input="courseChange" />
          <!-- <vs-select autocomplete class=" w-full" label="Course " @change="courseChange()" v-model="CourseClasssModel.CourseID" >
                     <vs-select-item :key="index" :value="item.ID" :text="item.Name" v-for="(item,index) in Courses" />
                          </vs-select> -->
        </div>

        <div class="vx-col lg:w-1/4">
          <label for="from" class="vs-input--label"> {{ $t('From') }}</label>
          <datepicker placeholder="from" v-model="CourseClasssModel.StartDate" class="vx-col  w-full" name="from"
            v-validate="'required'"></datepicker>
        </div>
        <div class="vx-col lg:w-1/4">
          <label for="to" class="vs-input--label"> {{ $t('To') }}</label>
          <datepicker placeholder="to" v-model="CourseClasssModel.EndDate" class="vx-col  w-full" name="to"
            v-validate="'required'"></datepicker>
        </div>
        <div class="vx-col lg:w-1/4">
          <label for="Provider" class="vs-input--label"> {{ $t('Provider') }} </label>
          <v-select label="Name" class=" w-full" v-model="CourseClasssModel.ProviderID" :options="Providers"
            :reduce="Provider => Provider.ID" />
          <!-- <vs-select class=" w-full" label="Provider " v-model="CourseClasssModel.ProviderID" >
                        <vs-select-item :key="index" :value="item.ID" :text="item.Name" v-for="(item,index) in Providers" />
                          </vs-select> -->
        </div>
        <div class="vx-col lg:w-1/2">
          <label for="Trainee" class="vs-input--label"> {{ $t('Trainee') }} </label>
          <!-- CourseClasssModel.Trainees -->
          <v-select label="FullName" class=" w-full" v-model="CourseClasssModel.Trainees" :options="Trainees" autocomplete
            multiple @input="traineeChange" :reduce="Trainee => Trainee.ID" />

          <!-- <v-select :dir="$vs.rtl ? 'rtl' : 'ltr'" label="Name" class="w-full" v-model="CourseClasssModel.Trainees"
                    :options="RolesList" multiple autocomplete :reduce="(value) => value.Id" /> -->

        </div>
        <div class="vx-col lg:w-1/4">
          <label for="Training Room" class="vs-input--label"> {{ $t('TrainingRoom') }}</label>
          <v-select label="Name" class=" w-full" v-model="CourseClasssModel.ClassRoomID" :options="classRooms"
            autocomplete :reduce="ClassRoom => ClassRoom.ID" />

        </div>

        <div class="vx-col lg:w-1/4">
          <label for="Mode" class="vs-input--label"> {{ $t('CourseType') }} </label>

          <v-select label="Name" class=" w-full" v-model="CourseClasssModel.CourseTypeID" :options="courseTypes"
            autocomplete :reduce="CourseType => CourseType.ID" />
        </div>
        <div class="vx-col lg:w-1/4">
          <p class="vs-input--label">{{ $t('Language') }}</p>
          <v-select label="Name" class="w-full" v-model="CourseClasssModel.LanguageID" :options="languages" autocomplete
            :reduce="Language => Language.ID" />
        </div>

        <div class="vx-col lg:w-1/4">
          <vs-input :label="$t('Location')" v-model="CourseClasssModel.Location" class="w-full" name="Location"
            v-validate="'required'" />
          <span class="text-danger text-sm" v-show="errors.has('Location')">{{ errors.first('Location') }}</span>
        </div>

        <div class="vx-row vx-col flex-1 mt-5" v-if="$acl.check('admin')">


          <div class="vx-row vx-col lg:w-1/4 mt-5" v-if="CourseClasssModel.CourseRequestID">
            <vs-checkbox :disabled="CourseClasssModel.AnnualPlanID" v-model="IsPublish">{{ $t('Publish') }}</vs-checkbox>
          </div>

        </div>

      </div>

    </vx-card>
    <vx-card class="p-5  mb-5" :title="$t('EvaluationMean')">
      <div class="data-list-container">
        <vs-prompt :title="$t('NewEvaluationMean')" :accept-text="$t('Save')" :cancel-text="$t('Cancel')"
          @cancel="clearEvaluationMeanModal" @accept="saveEvaluationMean" @close="clearEvaluationMeanModal"
          :is-valid="validateEvaluationMeanForm" :active.sync="activePrompt">
          <VuePerfectScrollbar class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
            <form @submit.prevent style="max-height:75vh;min-height:40vh">
              <p>{{ $t('Evaluation') }}</p>
              <v-select label="Name" class="w-full" v-model="evaluationMean.EvaluationMeanID" :options="evaluationMeans"
                :reduce="ID => ID.ID" />
              <div class="vx-col flex-1 mt-5 ">
                <p>{{ $t('Percentage') }}</p>
                <vs-input v-model="evaluationMean.Percentage" type="number" class="w-full" name="Percentage"
                  v-validate="'required'" />
                <span class="text-danger text-sm" v-show="errors.has('Percentage')">{{ errors.first('Percentage')
                }}</span>
              </div>
            </form>
          </VuePerfectScrollbar>
        </vs-prompt>

        <div slot="no-body" class="tabs-container pb-6">
          <div class="tab-text">
            <vs-button type="border" class="mb-4 mt-4" icon-pack="feather" icon="icon-plus"
              @click="activePrompt = true">{{ $t('AddEvaluationMean') }} </vs-button>

            <vs-table ref="table" pagination :max-items="itemsPerPage" :data="getEvaluationMeans">
              <template slot="thead">
                <vs-th sort-key="EvaluationMean">{{ $t('EvaluationMean') }}</vs-th>
                <vs-th sort-key="Num">{{ $t('Percentage') }}</vs-th>
                <vs-th>{{ $t('Action') }}</vs-th>
              </template>

              <template slot-scope="{data}">
                <tbody>
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                      <p class="product-name font-medium truncate">{{ tr.EvaluationMean.Name }}</p>
                    </vs-td>
                    <vs-td>
                      <p class="product-name font-medium truncate">{{ tr.Percentage }}</p>
                    </vs-td>
                    <vs-td class="whitespace-no-wrap">
                      <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                        @click.stop="editEvaluationMean(tr)" />
                      <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"
                        @click="openConfirm(tr)" />
                    </vs-td>
                  </vs-tr>
                </tbody>
              </template>
            </vs-table>

          </div>

        </div>
      </div>
    </vx-card>

    <vx-card class="p-5  mb-5" :title="$t('CourseClassNo')">
      <vx-card class="flex-1 mb-5" :title="$t('AddInstructor')">
        <div v-if="$acl.check('admin')">
          <vs-radio v-model="instructorType" vs-name="radios1" vs-value="1">{{ $t('AllInstructors') }}</vs-radio>
          <vs-radio v-model="instructorType" vs-name="radios1" class="ml-10" vs-value="2">
            {{ $t('InstructorsByCourse') }}</vs-radio>
        </div>
        <div class="vx-row">
          <div class="vx-col lg:w-1/4">
            <label for="Module" class="vs-input--label"> {{ $t('Module') }} </label>
            <v-select label="Name" class=" w-full" v-model="CourseClassInstructor.Module" :options="courseModules"
              autocomplete multiple :reduce="Module => Module" />
            <!-- <vs-select multiple autocomplete class=" w-full" label="Module " v-model="CourseClassInstructor.Module"  >
                        <vs-select-item :key="index" :value="item" :text="item.Name" v-for="(item,index) in courseModules" />
                              </vs-select> -->
          </div>

          <div class="vx-col lg:w-1/4">

            <label for="Instructor" class="vs-input--label"> {{ $t('Instructor') }} </label>
            <v-select label="Name" class=" w-full" v-model="CourseClassInstructor.Instructor" :options="allInstructors"
              autocomplete @search="FilterInstructor" v-if="instructorType == 1" :reduce="Module => Module" />
            <v-select label="Name" class=" w-full" v-model="CourseClassInstructor.Instructor" :options="instructors"
              autocomplete v-if="instructorType == 2" :reduce="Module => Module" />

            <span class="text-danger text-sm" v-show="errors.has('Instructor')">{{ errors.first('Instructor') }}</span>
          </div>

          <vs-button class="ml-6 mt-6" @click="addInstructor"> {{ $t('AddInstructor') }}</vs-button>

        </div>
      </vx-card>
      <vx-card class="flex-1 mb-5" :title="$t('Instructors')">
        <vs-table ref="table" class="flex-1" pagination :max-items="itemsPerPage" :data="GetCourseClassInstructors">
          <template slot="thead">
            <vs-th sort-key="Module">{{ $t('Module') }}</vs-th>
            <vs-th sort-key="Name">{{ $t('Instructor') }}</vs-th>
            <vs-th>{{ $t('Action') }}</vs-th>
          </template>
          <template slot-scope="{data}">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <p class="product-name font-medium truncate" v-if="tr.CourseModule != undefined">{{ tr.CourseModule.Name
                  }}
                  </p>
                </vs-td>
                <vs-td>
                  <p class="product-name font-medium truncate">{{ tr.Instructor.Name }}</p>
                </vs-td>
                <vs-td class="whitespace-no-wrap">
                  <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"
                    @click="deleteInstructor(tr.ID, indextr)" />
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </vx-card>

      <vx-card class="mb-5" :title="$t('Session')">
        <div class="vx-row">

          <!-- start date -->
          <div class="vx-col lg:w-1/3">
            <label for="startDate" class="vs-input--label">{{ $t('StartDate') }}</label>
            <flat-pickr :config="config" :placeholder="$t('StartDate')" v-model="CourseClassSession.Start" class="w-full"
              name="startDate"></flat-pickr>
            <span class="text-danger text-sm" v-show="errors.has('startDate')">{{ errors.first('startDate') }}</span>
          </div>

          <!-- End date -->
          <div class="vx-col lg:w-1/3 w-full">
            <label for="endDate" class="vs-input--label">{{ $t('EndDate') }}</label>
            <flat-pickr :config="config" :placeholder="$t('EndDate')" v-model="CourseClassSession.End" class="w-full"
              name="endDate"></flat-pickr>
            <span class="text-danger text-sm" v-show="errors.has('endDate')">{{ errors.first('endDate') }}</span>
          </div>

          <!-- Subject -->

        </div>
        <div class="vx-row">
          <div class="vx-col lg:w-3/4 w-full">
            <label for="Subject" class="vs-input--label"> {{ $t('Subject') }} </label>

            <quill-editor v-model="CourseClassSession.Subject" class="w-full" name="Subject" />
            <span class="text-danger text-sm" v-show="errors.has('Subject')">{{ errors.first('Subject') }}</span>
          </div>
          <vs-button style="height:45px" class="ml-6 mt-6" @click="addSession">{{ $t('AddSession') }}</vs-button>
        </div>
      </vx-card>

      <vx-card class="flex-1" :title="$t('SessionTable')">

        <vs-table ref="table" class="flex-1" pagination :max-items="itemsPerPage" :data="GetCourseClassSessions">
          <template slot="thead">
            <vs-th sort-key="Name">{{ $t('StartDate') }}</vs-th>
            <vs-th sort-key="Name">{{ $t('EndDate') }}</vs-th>
            <vs-th sort-key="Subject">{{ $t('Subject') }}</vs-th>
            <vs-th>{{ $t('Action') }}</vs-th>
          </template>
          <template slot-scope="{data}">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <p class="product-name font-medium truncate">{{ tr.Start.replace('T', ' ') }}</p>
                </vs-td>
                <vs-td>
                  <p class="product-name font-medium truncate">{{ tr.End.replace('T', ' ') }}</p>
                </vs-td>
                <vs-td>
                  <p class="product-name font-medium truncate" v-html="tr.Subject"></p>
                </vs-td>

                <vs-td class="whitespace-no-wrap">
                  <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"
                    @click="deleteSession(tr.ID, indextr)" />
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </vx-card>
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-end">
            <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!isFormValid">{{ $t('Submit') }} </vs-button>
            <vs-button class="ml-4 mt-2" type="border" color="danger" @click="cancle">{{ $t('Cancel') }}</vs-button>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import { quillEditor } from 'vue-quill-editor'
import vSelect from 'vue-select'
import axios from "@/axios.js"
import Datepicker from 'vuejs-datepicker';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import moduleCourseClass from "@/store/courseClass/moduleCourseClass.js";
import moduleCourse from "@/store/course/moduleCourse.js";
import moduleTrainee from "@/store/user/trainee/moduleTrainee.js";
import moduleClassRoom from "@/store/settings/classRoom/moduleClassRoom.js";
import moduleInstructor from "@/store/instructor/moduleInstructor.js";
// import moduleCourse from "@/store/course/moduleCourse.js";
import { domain, mainSetting } from '@/gloabelConstant.js';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import moduleCourseClassevaluationMean from "@/store/settings/courseClassevaluationMean/moduleCourseClassevaluationMean.js";
import moduleEvaluationMean from "@/store/settings/evaluationMean/moduleEvaluationMean.js";

export default {
  components: {
    vSelect,
    VuePerfectScrollbar,
    Datepicker,
    flatPickr,
    quillEditor
  },

  data() {
    return {
      evaluationMean:{},
      baseUrl: domain,
      activePrompt: false,
      disabledDates: {
        to: new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1), // Disable all dates up to specific date
        from: new Date(new Date().getFullYear() + 2, new Date().getMonth(), 1), // Disable all dates after specific date
        //daysOfMonth: [8, 11, 17], // Disable Specific days
      },
      instructorType: 1,
      showShareLink: false,
      UploadRequestHeader: mainSetting.UploadRequestHeader,
      config: {
        dateFormat: 'Y-m-d H:i ',
        enableTime: true,

      },
      instructors: [],
      courseModules: [],
      Providers: [],
      selected: [],
      activePrompt: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.30,
      },
      itemsPerPage: 10,
      isMounted: false,
      CourseClassInstructor: {},
      CourseClassSession: {},
      CourseClass: {},

      CourseClasssModel: {
        CourseClassSessions: [],
        CourseClassInstructors: [],
      },
      OldCourseClass: {},
      IsPublish: false,
      activeConfirm: false,

    };
  },
  computed: {
    evaluationMeans()
    {
      return this.$store.state.evaluationMeanList.evaluationMeans;
    },
    getEvaluationMeans()
    {
      return this.$store.state.courseClassList.courseClassEvaluationMeans;
    },
    courseClassevaluationMean()
    {
      return this.$store.state.courseClassevaluationMeanList.courseClassevaluationMean;
    },

    isFormValid() {
      return !this.errors.any();
    },
    Trainees() {
      return this.$store.state.traineeList.trainees;
    },
    CourseClasssTrainees() {
      return this.CourseClasssModel.Trainees;
    },
    Courses() {
      return this.$store.state.courseList.courses;
    },
    GetCourseClassInstructors() {

      return this.$store.state.courseClassList.courseClassInstructors;
    },
    GetCourseClassSessions() {
      return this.$store.state.courseClassList.courseClassSessions;
    },
    classRooms() {
      return this.$store.state.classRoomList.classRooms;
    },
    courseTypes() {
      return this.$store.state.courseList.courseTypes;
    },
    languages() {
      return this.$store.state.courseList.languages;
    },
    allInstructors() {

      return this.$store.state.instructorList.instructors;
    },
  },

  methods: {
    /////////Evalution mean mehtods //////////////////
    getTotalPercentage() {
      var total = 0;//a.reduce(function(a, b) { return a + b; }, 0);;

      this.getEvaluationMeans.forEach(element => {
        total += parseInt(element.Percentage);
      });
      return total;
    },

    editEvaluationMean(data) {
      this.evaluationMean = JSON.parse(JSON.stringify(data));
      this.activePrompt = true;
    },

    saveEvaluationMean() {
      debugger;
      const evaluationMeanIndex = this.evaluationMeans.findIndex((p) => p.ID == this.evaluationMean.EvaluationMeanID);
      this.evaluationMean.EvaluationMean = this.evaluationMeans[evaluationMeanIndex];
      //this.evaluationMean.EvaluationMeanID=this.evaluationMean.EvaluationMean.ID;

      this.deleteEvaluationMean(this.evaluationMean);
      var totalPercentage = this.getTotalPercentage();
      if (totalPercentage + parseInt(this.evaluationMean.Percentage) <= 100)
        this.$store.commit("courseClassList/ADD_CourseClassEvaluationMean", this.evaluationMean);
      else
        this.notifyAlert("danger", this.$t("Error"), this.$t("TotalEvaluationMeanPercentagemustbelessthan100"));

      this.clearEvaluationMeanModal();
    },

    clearEvaluationMeanModal() {
      this.evaluationMean = {}
    },

    deleteEvaluationMean(data) {
      debugger;
      if (data.ID != undefined)
        this.$store.dispatch("courseClassList/removeCourseClassEvaluationMean", data);
      this.$store.commit("courseClassList/REMOVE_CourseClassEvaluationMean", data.EvaluationMeanID);
    },

    openConfirm(data) {
      this.rowDataForDelete = data;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("Confirm"),
        text: this.$t("Areyousureyouwantdeletethisrecord") + "?",
        accept: this.acceptAlert
      });
    },

    acceptAlert() {
      this.deleteEvaluationMean(this.rowDataForDelete);
      this.notifyAlert("danger", this.$t("Deletedrecord"), this.$t("Theselectedrecordwassuccessfullydeleted"));

    },
    notifyAlert(color, title, text) {
      this.$vs.notify({
        fixed: true,
        color: color,
        title: title,
        text: text
      });
    },


    //////////////////////////////
    FilterInstructor(value) {

      this.$store.dispatch("instructorList/fetchDataListItemsByFilter", value);
    },
    getClassRoom() {

      if (!(this.CourseClasssModel.ClassRoomID > 0)) {
        this.CourseClasssModel.ClassRoomID = "";
      }
      //this.CourseClasssModel.ClassRoomID="";
      var search = {};
      if (this.CourseClasssModel.ID != undefined)
        search.CourseClassID = this.CourseClasssModel.ID;
      search.courseID = this.CourseClasssModel.CourseID;
      search.numOfTrainee = this.CourseClasssModel.Trainees.length;
      search.courseClassSessions = this.$store.state.courseClassList.courseClassSessions;
      debugger
      this.$store.dispatch("classRoomList/GetClassRoomsValidToCourseByCourseIDAndNum", search);
      debugger
    },
    courseChange() {

      this.getClassRoom();
      this.getCourseModules(this.CourseClasssModel.CourseID);
      this.getInstructors(this.CourseClasssModel.CourseID);


      this.GetCourseTypesByCourseID(this.CourseClasssModel.CourseID);
      this.GetLangaugesByCourseID(this.CourseClasssModel.CourseID);
    },
    GetLangaugesByCourseID(courseID) {
      this.$store.dispatch("courseList/GetLangaugesByCourseID", courseID);
    },
    GetCourseTypesByCourseID(courseId) {
      this.$store.dispatch("courseList/GetCourseTypesByCourseID", courseId);
    },
    traineeChange() {
      debugger
      this.getClassRoom();
      //var x = this.CourseClasssModel.Trainees;
      var loc = this.CourseClasssModel.Location;
      this.CourseClasssModel.Location += " ";
      this.CourseClasssModel.Location = loc;
      debugger
    },
    getInstructors(id) {

      axios.get("api/Course/GetInstructorByCourseID?courseID=" + id)
        .then((response) => {

          this.instructors = response.data;
        })
    },
    getProvider() {

      axios.get("api/Provider/GetAll")
        .then((response) => {

          this.Providers = response.data;
        })
    },
    getCourseModules(id) {

      axios.get("api/Course/GetCourseModulesByCourseID?courseID=" + id)

        .then((response) => {

          this.courseModules = response.data;
          this.courseModules.unshift({ Name: 'Select All', ID: 0 });
        })
    },

    deleteInstructor(data, index) {

      if (data > 0) {
        this.$store.dispatch("courseClassList/removeInstructor", data);

      }
      if (index >= 0) {

        this.$store.commit("courseClassList/REMOVE_courseClassInstructor", index);
      }

    },
    deleteSession(data, index) {
      debugger
      if (data > 0) {
        this.$store.dispatch("courseClassList/removeSession", data).then(() => {
          var obj = {};
          obj.courseClassID = this.$route.params.ID;
          this.$store.dispatch("courseClassList/GetSessionByCourseClassID", obj).then((response) => {
            this.CourseClasssModel.CourseClassSessions = response.data;
          });
        });
      }
      if (index >= 0) {
        this.$store.commit("courseClassList/REMOVE_courseClassSession", index);
      }
    },

    addInstructor() {

      var vm = this;
      debugger
      if (this.CourseClassInstructor.Module[0].Name == 'Select All') {
        this.courseModules.splice(0, 1)
        this.CourseClassInstructor.Module = this.courseModules;
        //this.courseModules.unshift({Name:'Select All',ID:0});
      }
      for (var i = 0; i < this.CourseClassInstructor.Module.length; i++) {
        var findex = this.$store.state.courseClassList.courseClassInstructors.findIndex(function (val) {
          return val.CourseModuleID == vm.CourseClassInstructor.Module[i].ID
        });
        if (findex == -1) {
          this.CourseClassInstructor.InstructorID = this.CourseClassInstructor.Instructor.ID;
          this.CourseClassInstructor.CourseModule = this.CourseClassInstructor.Module[i];
          this.CourseClassInstructor.CourseModuleID = this.CourseClassInstructor.Module[i].ID;
          this.$store.commit("courseClassList/ADD_courseClassInstructor", JSON.parse(JSON.stringify(this.CourseClassInstructor)));
        }
        else {
          this.$vs.notify({
            fixed: true,
            color: "danger",
            title: "Error",
            text: this.$t("Module") + this.CourseClassInstructor.Module[i].Name + this.$t("alreadyassigntoInstructor")
          });
        }
      }
      // this.CourseClasssModel.CourseClassInstructors=this.$store.state.courseClassList.courseClassInstructors;
      this.CourseClassInstructor = {};
      this.CourseClassInstructor.Module = [];
    },
    changeCourseDateFormat(d) {
      if (typeof d === 'string' || d instanceof String)
        return Date(d.split('T')[0] + '00:00:00');
      else
        return d
    },
    daysBetween(SelectedDateFrom, SelectedDateTo) {
      var millisecondsPerDay = 24 * 60 * 60 * 1000;
      return (new Date(SelectedDateTo.split(" ")[0]) - new Date(SelectedDateFrom.split(" ")[0])) / millisecondsPerDay;
    },
    getDateInt(val) {
      if (val < 10) {
        return '0' + val;
      }
      else {
        return val;
      }
    },
    convertFromjsDateToString(date) {
      return date.getFullYear() + '-' + this.getDateInt(date.getMonth() + 1) + '-' + this.getDateInt(date.getDate()) + ' ' + this.getDateInt(date.getHours()) + ':' + this.getDateInt(date.getMinutes()) + ':00';
    },
    addSession() {
      debugger
      //calculate number of days between start and end date
      //   var Difference_In_Time = this.CourseClasssModel.EndDate.getTime() -  this.CourseClasssModel.StartDate.getTime();
      //   var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
      //  for(i = 0 ; i>=Difference_In_Days ;i++)
      //  {

      //  }
      //  const start = new Date(this.CourseClasssModel.StartDate) //clone
      // const end = new Date(this.CourseClasssModel.EndDate) //clone
      // let dayCount = 0

      // while (end >= start) {
      //   dayCount++
      //   start.setDate(start.getDate() + 1)
      // }
      //  i++;
      var f, e;
      if (typeof this.CourseClasssModel.StartDate === 'string' || this.CourseClasssModel.StartDate instanceof String)
        f = new Date(this.CourseClasssModel.StartDate.split('T')[0]);
      else
        f = this.CourseClasssModel.StartDate;

      if (typeof this.CourseClasssModel.EndDate === 'string' || this.CourseClasssModel.EndDate instanceof String)
        e = new Date(this.CourseClasssModel.EndDate.split('T')[0]);
      else
        e = this.CourseClasssModel.EndDate;

      if (new Date(this.CourseClassSession.Start).getTime() >= (f.getTime() - (24 * 60 * 60 * 1000)) && new Date(this.CourseClassSession.End).getTime() <= (e.getTime() + (24 * 60 * 60 * 1000))) {
        var daynum = this.daysBetween(this.CourseClassSession.Start, this.CourseClassSession.End);
        if (daynum > 0) {
          for (var i = 0; i <= daynum; i++) {
            var obj = {};
            var startdate = new Date(this.CourseClassSession.Start);
            var enddate = new Date(this.CourseClassSession.End);
            obj.Start = this.convertFromjsDateToString(new Date(startdate.setDate(startdate.getDate() + i)));
            obj.End = this.convertFromjsDateToString(new Date(enddate.setDate(enddate.getDate() - (daynum - i))));
            obj.Subject = this.CourseClassSession.Subject;
            this.$store.commit("courseClassList/ADD_courseClassSession", obj);
          }
        }
        else
          this.$store.commit("courseClassList/ADD_courseClassSession", this.CourseClassSession);

        this.CourseClasssModel.CourseClassSessions = this.$store.state.courseClassList.courseClassSessions;
        this.CourseClassSession = {};
        this.getClassRoom();
      }
      else {
        this.$vs.notify({
          fixed: true,
          color: "danger",
          title: "Error Date",
          text: this.$t("Sessionmustbewithencourseclassdates")

        });
      }
      //    this.CourseClassSession.Start.setDate(this.CourseClassSession.Start.getDate() + 1)

    },
    cancle() {
      this.$router.push('/CourseClass');
    },
    save_changes() {
      this.CourseClasssModel.CourseClassAttendees = this.CourseClasssModel.Trainees.map(function (val) { var obj = {}; obj.TraineeID = val; return obj; });
      this.CourseClasssModel.IsPublish = this.IsPublish;
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.CourseClasssModel.ID !== null && this.CourseClasssModel.ID !== undefined) {
            this.$vs.loading();
            this.CourseClasssModel.OldCourseClass = this.OldCourseClass;
            this.$store.dispatch("courseClassList/updateItem", this.CourseClasssModel).then(() => {
              this.$vs.loading.close();
              this.$store.state.courseClassList.search.pageNum = 1;
              this.$router.push('/CourseClass');
            }).catch(err => {
              this.$vs.loading.close();
              console.error(err);
            });
          }
          else {
            this.$vs.loading();
            this.$store.dispatch("courseClassList/addItem", this.CourseClasssModel).then(() => {
              this.$vs.loading.close();
              this.$store.state.courseClassList.search.pageNum = 1;
              this.$router.push('/CourseClass');
            }).catch(err => {
              this.$vs.loading.close();
              console.error(err);
            });

          }
        }
      });
    },

  },

  created() {
    if (!moduleEvaluationMean.isRegistered) {
      this.$store.registerModule("evaluationMeanList", moduleEvaluationMean);
      moduleEvaluationMean.isRegistered = true;
    }
    this.$store.dispatch("evaluationMeanList/fetchDataListItems");

    if (!moduleCourseClassevaluationMean.isRegistered) {
      this.$store.registerModule("CourseClassCourseClassevaluationMeanList", moduleCourseClassevaluationMean);
      moduleCourseClassevaluationMean.isRegistered = true;
    }
    this.$store.dispatch("CourseClassevaluationMeanList/fetchDataListItems");

    if (!moduleClassRoom.isRegistered) {
      this.$store.registerModule("classRoomList", moduleClassRoom);
      moduleClassRoom.isRegistered = true;
    }
    if (!moduleTrainee.isRegistered) {
      this.$store.registerModule("traineeList", moduleTrainee);
      moduleTrainee.isRegistered = true;
    }
    this.$store.dispatch("traineeList/fetchDataListItems");

    if (!moduleCourseClass.isRegistered) {
      this.$store.registerModule("courseClassList", moduleCourseClass);
      moduleCourseClass.isRegistered = true;
    }
    if (!moduleInstructor.isRegistered) {
      this.$store.registerModule("instructorList", moduleInstructor);
      moduleInstructor.isRegistered = true;
    }

    if (!moduleCourse.isRegistered) {
      this.$store.registerModule("courseList", moduleCourse);
      moduleCourse.isRegistered = true;
    }

    this.$store.commit("courseList/SET_CourseTypes", []);
    this.$store.commit("courseList/SET_CourseLanguages", []);

    this.$store.dispatch("courseList/fetchDataListItems");
    this.$store.dispatch("instructorList/fetchDataListItemsByFilter", " ");
    this.CourseClasssModel = {};
    this.$store.commit("courseClassList/SET_courseClassSession", []);
    this.$store.commit("courseClassList/SET_courseClassInstructor", []);
    const ID = this.$route.params.ID
    this.IsPublish = false;
    this.showShareLink = false;

    if (ID != undefined) {

      this.$store.dispatch("courseClassList/GetItemByID", ID).then(res => {
        this.OldCourseClass = JSON.parse(JSON.stringify(res.data));

        this.CourseClasssModel = res.data;
        this.showShareLink = this.CourseClasssModel.CourseRequestID != null;

        this.IsPublish = this.CourseClasssModel.IsPublish;
        this.CourseClasssModel.Trainees = this.CourseClasssModel.CourseClassAttendees.map(a => a.TraineeID);
        this.getCourseModules(this.CourseClasssModel.CourseID);
        this.getInstructors(this.CourseClasssModel.CourseID);
        this.GetCourseTypesByCourseID(this.CourseClasssModel.CourseID);
        this.GetLangaugesByCourseID(this.CourseClasssModel.CourseID);
        this.$store.commit("courseClassList/SET_courseClassSession", this.CourseClasssModel.CourseClassSessions);
        this.$store.commit("courseClassList/SET_courseClassInstructor", this.CourseClasssModel.CourseClassInstructors);
        this.getClassRoom();
      });

    }
    else {
      this.$store.dispatch("courseClassList/GetClassNoCode").then(res => {
        console.log(res);
        this.CourseClasssModel.ClassNo = res.data;
      }).catch(err => {
        console.error(err);
      });

    }
    // this.CourseClasssModel=this.$store.state.courseClassList;
    this.CourseClassInstructor.Module = [];
    this.CourseClasssModel.Trainees = [];

    this.getProvider();


  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }

  .con-select .vs-select {
    width: 100%
  }
}

.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
}

#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }

  }
}
</style>
